import { atom } from 'jotai'

export const isTimeoutAtom = atom(false)
export const showModalAtom = atom(false)
export const startCountDownAtom = atom(true)
export const paylogConfiguredAtom = atom(null) // null = not checked, true = paylog configured, false = local remita